function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';
var UndrawSubscriber = function UndrawSubscriber(_props) {
  var props = Object.assign({}, _props);
  var primaryColor = props.primaryColor || defaultProps.primaryColor;
  var style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1023.623 795.001",
    style: style
  }, props), React.createElement("circle", {
    cx: 541,
    cy: 373,
    r: 373,
    fill: "#f2f2f2"
  }), React.createElement("path", {
    d: "M912 747c0 15.465-204.158 48-456 48S0 762.466 0 747s204.158-8 456-8 456-7.463 456 8z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M912 747c0 15.465-204.158 48-456 48S0 762.466 0 747s204.158-8 456-8 456-7.463 456 8z",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 456,
    cy: 747.001,
    rx: 456,
    ry: 28,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 459,
    cy: 737.001,
    rx: 184,
    ry: 17,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M739 614.913c0 63.204 39.651 114.348 88.652 114.348",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M827.652 729.26c0-63.913 44.248-115.632 98.93-115.632M771.12 620.642c0 60.038 25.285 108.619 56.532 108.619",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M827.652 729.26c0-81.667 51.144-147.752 114.348-147.752",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M809.002 730.067s12.572-.387 16.361-3.085 19.34-5.92 20.28-1.593 18.893 21.521 4.7 21.636-32.982-2.211-36.763-4.515-4.578-12.443-4.578-12.443z",
    fill: "#a8a8a8"
  }), React.createElement("path", {
    d: "M850.595 745.519c-14.194.114-32.98-2.211-36.762-4.515-2.88-1.754-4.027-8.05-4.411-10.953l-.42.016s.796 10.14 4.578 12.443 22.568 4.63 36.762 4.515c4.097-.033 5.513-1.491 5.435-3.65-.57 1.304-2.132 2.119-5.182 2.144z",
    opacity: 0.2
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M355 612.001h226v132H355z"
  }), React.createElement("path", {
    d: "M627.918 613.127h-166.62a20.602 20.602 0 0 1-20.602-20.602v-76.337a8.162 8.162 0 0 1 2.547-5.924l88.292-83.693a19.003 19.003 0 0 1 26.146 0l84.182 79.797a21.334 21.334 0 0 1 6.657 15.483v70.674a20.602 20.602 0 0 1-20.601 20.602z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    d: "M440.696 517.441h206.093v66.954a28.732 28.732 0 0 1-28.733 28.732H469.428a28.732 28.732 0 0 1-28.732-28.732V517.44z",
    opacity: 0.1
  }), React.createElement("rect", {
    x: 467.757,
    y: 451.847,
    width: 153.27,
    height: 153.27,
    rx: 11.336,
    fill: primaryColor
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M621.027 520.883v84.234h-153.27v-84.234l76.635 37.041 76.635-37.041z"
  }), React.createElement("path", {
    d: "M544.392 562.686l-98.195-47.46a3.984 3.984 0 0 0-5.717 3.587v81.657a12.44 12.44 0 0 0 12.44 12.44h182.944a12.44 12.44 0 0 0 12.44-12.44v-80.258a4.862 4.862 0 0 0-6.977-4.377z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    fill: "#f2f2f2",
    d: "M480.962 465.918h42.864v6.062h-42.864zM477.498 487.999H604.79v3.464H477.498zM477.498 499.69H604.79v3.464H477.498zM477.498 511.38H604.79v3.464H477.498z"
  }), React.createElement("ellipse", {
    cx: 474.035,
    cy: 454.26,
    rx: 17.752,
    ry: 17.784,
    fill: "#fff"
  }), React.createElement("path", {
    d: "M474.035 433.446a21.215 21.215 0 1 0 21.215 21.215 21.278 21.278 0 0 0-21.215-21.215zm-4.356 32.526L458.806 455.1l3.05-3.05 7.833 7.833 16.534-16.534 3.05 3.05-19.594 19.573z",
    fill: "#57b894"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M563.623 111.008h460v192h-460z"
  }), React.createElement("path", {
    d: "M749.453 259.008h-52a181.872 181.872 0 0 1 0-62h52a111.559 111.559 0 0 0 0 62zM894.784 259.008h-52a181.872 181.872 0 0 1 0-62h52a111.559 111.559 0 0 0 0 62z",
    fill: "#ff6584"
  }), React.createElement("path", {
    d: "M675.623 217.008h-52a181.872 181.872 0 0 1 0-62h52a111.559 111.559 0 0 0 0 62zM768.623 217.008h52a181.872 181.872 0 0 0 0-62h-52a111.559 111.559 0 0 1 0 62zM911.623 217.008h52a181.872 181.872 0 0 0 0-62h-52a111.559 111.559 0 0 1 0 62z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M253.88 161.93a7.43 7.43 0 0 0-4.31.963 11.243 11.243 0 0 0-2.916 3.848 46.029 46.029 0 0 1-12.539 14.164c-3.726 2.73-8.463 6.133-7.825 11.165a15.09 15.09 0 0 0 1.816 4.713c3.437 6.939 12.817 12.3 11.894 20.218 3.415-5.717-1.153-8.544 2.262-14.26 1.626-2.723 4.452-5.797 6.907-4.087.822.573 1.362 1.6 2.218 2.102 2.042 1.198 4.215-1.093 6.023-2.716 6.235-5.597 15.101-4.13 22.86-2.387 3.662.823 7.685 1.903 9.85 5.404 2.847 4.603-2.705 9.574-4.107 14.777a2.835 2.835 0 0 0 3.043 3.53c2.328-.23 5.085-.419 5.223-1.44 2.93.104 6.518-.228 7.773-3.278a12.824 12.824 0 0 0 .601-3.729c.46-5.123 2.635-9.797 4.076-14.672s2.066-10.59-.364-14.913a17.256 17.256 0 0 0-3.185-3.871c-13.794-13.35-31.93-15.55-49.3-15.53z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    d: "M243 227s3 25-8 27 10 36 10 36l50 6-12-40s-8-3-3-23-37-6-37-6zM212.5 656.501l4 55h21l-6-55h-19zM366.5 552.501l3 46 23-10-9-38-17 2z",
    fill: "#a0616a"
  }), React.createElement("path", {
    d: "M197.5 446.5s1 58 7 77 5 20 4 23-2 1-2 6-2 84 0 91-6 19 0 20 34 0 35-6-8-8-4-12 10-86 10-86l14-57 26-30h55l17 66s-7 19-2 19 35 6 35-16-10-87-12-89 1-9-2-12-38-24-51-28-31.237-8.76-31.237-8.76zM392.5 580.5s-15-5-22 10-4 19-4 19 23 8 27 4c1.74-1.74 7.266-2.344 12.955-2.472 8.663-.194 10.968-12.451 2.786-15.305q-.366-.128-.741-.222c-8-2-16-15-16-15z",
    fill: "#2f2e41"
  }), React.createElement("circle", {
    cx: 265.5,
    cy: 213.501,
    r: 30,
    fill: "#a0616a"
  }), React.createElement("path", {
    d: "M226.5 266.5s49 10 61-6 17 45 17 45l6 64-9 35s-47 38-62 41-38 5-38 5 7-111 7-113 18-71 18-71z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M241.402 247.746s-10.902-6.245-13.902-.245-31 21-34 21 6 83 2 93-23 83-12 89 3-6 14 9 65 15 68 9-24-51-19-93 13-100 6-108-11.098-19.755-11.098-19.755zM277.5 254.5l1.393-4.793s41.607 13.794 43.607 22.794 1 72-6 77-17 13-10 25 15 25 21 26 17 8 14 15-39-6-39-6-24-18-23-46-2-109-2-109z",
    fill: "#575a89"
  }), React.createElement("path", {
    d: "M312.5 372.5l-24 45s-35 36-15 40 31-33 31-33l26-37z",
    fill: "#a0616a"
  }), React.createElement("path", {
    d: "M255.34 169.78a6.809 6.809 0 0 0-3.508.68 8.177 8.177 0 0 0-2.373 2.72 34.55 34.55 0 0 1-10.207 10.01c-3.033 1.93-6.89 4.335-6.37 7.892a9.868 9.868 0 0 0 1.478 3.331 26.203 26.203 0 0 1 3.184 16.333l8.34-12.122c1.324-1.924 3.624-4.097 5.622-2.888.67.404 1.109 1.13 1.806 1.485 1.663.847 3.431-.772 4.903-1.92 5.075-3.955 12.293-2.919 18.608-1.686 2.982.582 6.257 1.345 8.02 3.82 2.928 4.11-.13 10.052 1.58 14.802a4.364 4.364 0 0 0 1.805-2.882c2.384.074 5.306-.16 6.327-2.316a7.981 7.981 0 0 0 .49-2.636c.375-3.62 2.145-6.924 3.317-10.37s1.683-7.485-.296-10.54a12.754 12.754 0 0 0-2.592-2.736c-11.23-9.435-25.993-10.991-40.133-10.977z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    d: "M312.5 268.5l9.317 2.474S343.5 326.5 338.5 364.5s-8 30-8 30-8-18-26-14z",
    fill: "#575a89"
  }), React.createElement("path", {
    d: "M213.885 704.232c-2.411 3.277-1.928 7.961-4.064 11.424-1.851 3.002-5.34 4.576-7.657 7.235a19.395 19.395 0 0 0-1.968 2.832c-2.149 3.599-3.895 8.21-1.78 11.829 1.703 2.91 5.28 4.048 8.562 4.823 4.147.98 8.456 1.764 12.651 1.015s8.296-3.317 9.791-7.308a28.23 28.23 0 0 1 1.047-2.954c2.274-4.476 9.406-4.525 11.733-8.974 1.629-3.113.132-6.877-1.365-10.056l-4.57-9.71c-1.517-3.221-7.665-1.368-10.87-2.14-4.18-1.008-8.502-2.117-11.51 1.984z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M234.202 479.085l17.732 24.145 69.149-35.727 3.989-2.052-86.396-5.58-4.474 19.214z"
  }), React.createElement("path", {
    opacity: 0.2,
    d: "M235.165 480.395l16.769 22.835 69.149-35.727-85.918 12.892z"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M228.704 507.245l3.207-20.939 93.509-20.835-96.716 41.774z"
  }), React.createElement("path", {
    d: "M180.5 392.5l42 65s26 33 34 18-28-40-28-40l-27-50z",
    fill: "#a0616a"
  }), React.createElement("path", {
    d: "M201.5 270.5l-8-2s-16 5-20 26-1 105 4 106 24.695-14.625 27.847-11.312S198.5 375.5 201.5 366.5s0-96 0-96z",
    fill: "#575a89"
  }));
};
UndrawSubscriber.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawSubscriber;